import { Center, Loader } from '@mantine/core';
import { useAppContainerContext } from './AppContainerContext';
import { SiestaBar } from './sidebar/SiestaBar';

export function DefaultSidebar() {
  const { skipDefaultSidebar } = useAppContainerContext();

  if (skipDefaultSidebar) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  return <SiestaBar />;
}
